import { IconProps, IconSizes } from "../icon-prop-types";

export const CheckboxSelectedIcon = ({ size = "small" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 20 20"
      style={{ borderRadius: "4px" }}
    >
      <title>Checkbox Selected</title>
      <defs>
        <path
          d="M4.11025,10 L0.29325,6.297 C-0.09775,5.918 -0.09775,5.303 0.29325,4.923 C0.68425,4.544 1.31825,4.544 1.70925,4.923 L4.11025,7.252 L11.29025,0.285 C11.68225,-0.095 12.31525,-0.095 12.70625,0.285 C13.09825,0.664 13.09825,1.279 12.70625,1.659 L4.11025,10 Z"
          id="checkbox-selected-path-1"
        ></path>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-276.000000, -226.000000)">
          <g transform="translate(276.000000, 226.000000)">
            <rect
              stroke="#0070C8"
              fill="#0070C8"
              x="0.5"
              y="0.5"
              width="19"
              height="19"
            ></rect>
            <g id="checkmark" transform="translate(3.500000, 6.142857)">
              <mask id="checkbox-selected-mask-2" fill="#FFFFFF">
                <use xlinkHref="#checkbox-selected-path-1"></use>
              </mask>
              <use
                id="Mask"
                fill="#FFFFFF"
                xlinkHref="#checkbox-selected-path-1"
              ></use>
              <g
                id="Group"
                mask="url(#checkbox-selected-mask-2)"
                fill="#FFFFFF"
              >
                <g id="↳-Icon-Color"></g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default CheckboxSelectedIcon;
